__turbopack_context__.v({
  "closeIcon": "headerBanner-module-scss-module__n6nZVW__closeIcon",
  "closedBanner": "headerBanner-module-scss-module__n6nZVW__closedBanner",
  "container": "headerBanner-module-scss-module__n6nZVW__container",
  "content": "headerBanner-module-scss-module__n6nZVW__content",
  "headerBanner": "headerBanner-module-scss-module__n6nZVW__headerBanner",
  "headerBannerFixed": "headerBanner-module-scss-module__n6nZVW__headerBannerFixed",
  "ieWrapper": "headerBanner-module-scss-module__n6nZVW__ieWrapper",
});
